import { DropDownBox, DropDownBoxLayoutStyle } from '@apply/components';
import { BrokerAgreementSummary } from '../../../../../../../queries/brokerAgreementQueries';

interface PrimaryEntityFieldProps {
    value: number | null;
    onChange: (entityId: number | null) => void;
    /** The agreement's borrower entities to choose from. */
    entities: BrokerAgreementSummary['borrowerEntities'];
}

/** Chooses the agreement's primary entity from its borrower entities. */
export const PrimaryEntityField = ({ value, onChange, entities }: PrimaryEntityFieldProps) => {
    return (
        <DropDownBox
            id='brokerAgreementPrimaryEntity'
            value={value}
            onChange={onChange}
            label='Primary Entity'
            dataSource={entities ?? []}
            displayExpr='entityName'
            valueExpr='entityId'
            placeholder='Select'
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
